import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_discipline } from "../shared/data.service";

import { DisciplineAddEditCommentComponent } from "./disciplineaddeditcomment/disciplineaddeditcomment.component";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { ViewChild } from "@angular/core";
import * as moment from "moment";
import {
	wsDisciplineAdvancedIncidentStudentDataInfo,
	wsDisciplineAdvancedIncidentPenaltyRefreshInfo,
	wsDisciplineAdvancedIncidentFacilityLocationDataInfo,
	wsDisciplineAdvancedIncidentCommentInfo,
	wsDisciplineAdvancedIncidentAssignedInfractionInfo,
	wsDisciplineAdvancedIncidentInfractionInfo,
	wsDisciplineAdvancedIncidentAssignedPenaltyInfo,
	wsDisciplineAdvancedIncidentPenaltyInfo,
	wsDisciplineAdvancedIncidentStudentDataParm,
	wsDisciplineAdvancedIncidentCalendarDataParm,
	wsDisciplineAdvancedIncidentCalendarDataInfo,
	wsDisciplineAdvancedIncidentPenaltyRefreshInfractionsParm,
	wsDisciplineAdvancedIncidentPenaltyRefreshParm,
	wsDisciplineAdvancedIncidentAddUpdateComment,
	wsDisciplineAdvancedIncidentAddUpdateInfraction,
	wsDisciplineAdvancedIncidentAddUpdatePenalty,
	wsDisciplineAdvancedIncidentAddUpdateParm,
} from "../shared/ws-discipline-modify-info";

@Component({
	selector: "app-root",
	templateUrl: "./disciplineaddeditadvanced.component.html",
	styleUrls: ["./disciplineaddeditadvanced.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class DisciplineAddEditAdvancedComponent implements OnInit, OnDestroy {
	@ViewChild("dtComments") dtComments: Table;
	@ViewChild("dtAssignedInfractions") dtAssignedInfractions: Table;
	@ViewChild("dtUnassignedInfractions") dtUnassignedInfractions: Table;
	@ViewChild("filterInfractionSchoolsDesc", { static: false })
	public filterInfractionSchoolsDesc: Dropdown;
	@ViewChild("filterInfractionDefinedByDesc", { static: false })
	public filterInfractionDefinedByDesc: Dropdown;

	@ViewChild("dtAssignedActions") dtAssignedActions: Table;
	@ViewChild("dtUnassignedActions") dtUnassignedActions: Table;
	@ViewChild("filterActionSchoolsDesc", { static: false })
	public filterActionSchoolsDesc: Dropdown;
	@ViewChild("filterActionDefinedByDesc", { static: false })
	public filterActionDefinedByDesc: Dropdown;

	constructor(
		private dataService: DataService_discipline,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;
	public isShowInfractionAInfo: boolean = false;
	public isShowInfractionUInfo: boolean = false;
	public isShowActionAInfo: boolean = false;
	public isShowActionUInfo: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public PersonID: number = -1;
	public IncidentID: number = -1;
	public SchoolID: number = -1;
	public isAdd: boolean = false;

	public IncidentData: wsDisciplineAdvancedIncidentStudentDataInfo;
	public RefreshPenaltyData: wsDisciplineAdvancedIncidentPenaltyRefreshInfo;

	public lstFacilityLocationItems: wsDisciplineAdvancedIncidentFacilityLocationDataInfo[] = [];
	public SelectedFacilityLocation: wsDisciplineAdvancedIncidentFacilityLocationDataInfo;
	public lstCommentItems: wsDisciplineAdvancedIncidentCommentInfo[] = [];
	public SelectedComment: wsDisciplineAdvancedIncidentCommentInfo;

	public lstAssignedInfractionItems: wsDisciplineAdvancedIncidentAssignedInfractionInfo[] = [];
	public SelectedAssignedInfraction: wsDisciplineAdvancedIncidentAssignedInfractionInfo;
	public lstInfractionItems: wsDisciplineAdvancedIncidentInfractionInfo[] = [];
	public SelectedInfraction: wsDisciplineAdvancedIncidentInfractionInfo;

	public lstAssignedPenaltyItems: wsDisciplineAdvancedIncidentAssignedPenaltyInfo[] = [];
	public SelectedAssignedPenalty: wsDisciplineAdvancedIncidentAssignedPenaltyInfo;
	public lstPenaltyItems: wsDisciplineAdvancedIncidentPenaltyInfo[] = [];
	public SelectedPenalty: wsDisciplineAdvancedIncidentPenaltyInfo;

	public rAdminName: string = "";
	public rStudentID: string = "";
	public rFirstName: string = "";
	public rLastName: string = "";
	public rIncidentDT: Date = null;
	public rContinueAlert: boolean = false;
	public rIsUseDayCount: boolean = false;
	public rMinDurationDayCount: number = 1;
	public rMaxDurationDayCount: number = 1;
	public rHasSusp: boolean = false;
	public selectedRadioValue: string = "1";

	//	RadioValue1
	public rSuspNbrDays1: number = 1;
	public rStartDate1: Date = null;
	public rEndDate1: Date = null;

	//	RadioValue2
	public rSuspNbrDays2: number = 1;
	public rStartDate2: Date = null;
	public rEndDate2: Date = null;

	//	Sound Player
	public mp3Player: any = new Audio();

	//	DataTable page counts
	public C_pagefirst: number = 0;
	public C_pagerows: number = 3;

	public AI_pagefirst: number = 0;
	public AI_pagerows: number = 3;
	public UI_pagefirst: number = 0;
	public UI_pagerows: number = 5;

	public AA_pagefirst: number = 0;
	public AA_pagerows: number = 3;
	public UA_pagefirst: number = 0;
	public UA_pagerows: number = 5;

	//	Filters
	public lstInfractionSchoolsDescs: any = [];
	public lstInfractionDefinedByDescs: any = [];
	public lstActionSchoolsDescs: any = [];
	public lstActionDefinedByDescs: any = [];

	//	Error Messaging
	public ErrorMessage: string = "";

	// Portal Apps
	public ParentPortalSendNotification: boolean = false;
	public StudentPortalSendNotification: boolean = false;
	public StaffPortalSendNotification: boolean = false;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.PersonID = this.dialogConfig.data.PersonID;
		this.IncidentID = this.dialogConfig.data.IncidentID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.isAdd = this.dialogConfig.data.isAdd;

		let parm: wsDisciplineAdvancedIncidentStudentDataParm = {
			UserID: this.UserID,
			PersonID: this.PersonID,
			IncidentID: this.IncidentID,
			SchoolID: this.SchoolID,
		};

		this.isBusy = true;
		this.dataService.DisciplineAdvancedIncidentGetStudentData(parm).subscribe((data) => this.DisciplineAdvancedIncidentGetStudentData_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentGetStudentData_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentGetStudentData_Complete(data: any) {
		this.IncidentData = data;

		this.lstFacilityLocationItems = this.IncidentData.FacilityLocationItems;
		this.lstCommentItems = this.IncidentData.CommentItems;
		this.lstAssignedInfractionItems = this.IncidentData.AssignedInfractionItems;
		this.lstAssignedPenaltyItems = this.IncidentData.AssignedPenaltyItems;
		this.lstInfractionItems = this.IncidentData.InfractionItems;
		this.lstPenaltyItems = this.IncidentData.PenaltyItems;

		this.rAdminName = this.IncidentData.AdminName;
		this.rStudentID = this.IncidentData.StudentID;
		this.rFirstName = this.IncidentData.FirstName;
		this.rLastName = this.IncidentData.LastName;
		this.rContinueAlert = this.IncidentData.ContinueAlert;

		this.rIsUseDayCount = this.IncidentData.IsUseDayCount;
		this.rSuspNbrDays1 = this.IncidentData.DayCount;
		this.rSuspNbrDays2 = this.IncidentData.DayCount;

		this.rStartDate1 = null; // Set Later
		this.rEndDate1 = null; // Set Later
		this.rStartDate2 = null; // Set Later
		this.rEndDate2 = null; // Set Later

		this.rHasSusp = false;
		this.rMinDurationDayCount = 0;
		this.rMaxDurationDayCount = 0;

		//
		//	Select Default Facility Location
		//
		this.lstFacilityLocationItems.unshift({
			FacilityLocationID: -1,
			FacilityLocationCD: "",
			FacilityLocationName: "(None Selected)",
		});

		this.SelectedFacilityLocation = this.lstFacilityLocationItems[0];

		this.lstFacilityLocationItems.forEach((item) => {
			if (item.FacilityLocationID == this.IncidentData.FacilityLocationID) {
				this.SelectedFacilityLocation = item;
			}
		});

		//
		//	Set SUSP info if have SUSP
		//
		this.lstAssignedPenaltyItems.forEach((item) => {
			if (item.isSusp == true) {
				this.rHasSusp = true;
				this.rMinDurationDayCount = item.MinDurationDayCount; // Will only have 1 susp per Incident
				this.rMaxDurationDayCount = item.MaxDurationDayCount; // Will only have 1 susp per Incident
			}
		});

		if (this.rIsUseDayCount == false) {
			this.selectedRadioValue = "1"; // Date Range
		} else {
			this.selectedRadioValue = "2"; // Day Count
		}

		// Start / End Date
		if (this.IncidentData.StartDate != null) {
			this.rStartDate1 = new Date(this.IncidentData.StartDate); // Must do new for this to work
			this.rStartDate2 = new Date(this.IncidentData.StartDate); // Must do new for this to work
		}

		if (this.IncidentData.EndDate != null) {
			this.rEndDate1 = new Date(this.IncidentData.EndDate); // Must do new for this to work
			this.rEndDate2 = new Date(this.IncidentData.EndDate); // Must do new for this to work
		}

		// SET IncidentDT
		if (this.IncidentData.IncidentDT == null) {
			this.rIncidentDT = null;
		} else {
			this.rIncidentDT = new Date(this.IncidentData.IncidentDT); // Must do new for this to work
		}

		//
		//	Set Filter Lists
		//
		this.lstInfractionSchoolsDescs = Array.from(new Set(this.lstInfractionItems.map((item: any) => item.SchoolsDesc)));
		this.lstInfractionDefinedByDescs = Array.from(new Set(this.lstInfractionItems.map((item: any) => item.DefinedByDesc)));

		this.lstActionSchoolsDescs = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.SchoolsDesc)));
		this.lstActionDefinedByDescs = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.DefinedByDesc)));

		//
		//	Set Filter Defaults
		//
		this.onSetInfractionFilterDefaults();
		this.onSetActionFilterDefaults();

		//
		//	Reset Sort
		//
		this.dtComments.multiSortMeta = [];
		this.dtComments.multiSortMeta.push({ field: "c_date", order: -1 }); // DESC)
		this.dtComments.sortMultiple();

		this.dtAssignedInfractions.multiSortMeta = [];
		this.dtAssignedInfractions.multiSortMeta.push({
			field: "InfractionDesc",
			order: 1,
		});
		this.dtAssignedInfractions.sortMultiple();

		this.dtUnassignedInfractions.multiSortMeta = [];
		this.dtUnassignedInfractions.multiSortMeta.push({
			field: "InfractionDesc",
			order: 1,
		});
		this.dtUnassignedInfractions.sortMultiple();

		this.dtAssignedActions.multiSortMeta = [];
		this.dtAssignedActions.multiSortMeta.push({
			field: "PenaltyDesc",
			order: 1,
		});
		this.dtAssignedActions.sortMultiple();

		this.dtUnassignedActions.multiSortMeta = [];
		this.dtUnassignedActions.multiSortMeta.push({
			field: "PenaltyDesc",
			order: 1,
		});
		this.dtUnassignedActions.sortMultiple();

		this.ParentPortalSendNotification = this.IncidentData.ParentPortalSendNotification;
		this.StudentPortalSendNotification = this.IncidentData.StudentPortalSendNotification;
		this.StaffPortalSendNotification = this.IncidentData.StaffPortalSendNotification;

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetInfractionFilterDefaults
	//
	//-----------------------------------------------------------------------------------------------------
	onSetInfractionFilterDefaults() {
		this.dtUnassignedInfractions.filters.SchoolsDesc["value"] = null; // Default To 'Any'
		this.dtUnassignedInfractions.filters.DefinedByDesc["value"] = null; // Default To 'Any'
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetActionFilterDefaults
	//
	//-----------------------------------------------------------------------------------------------------
	onSetActionFilterDefaults() {
		this.dtUnassignedActions.filters.SchoolsDesc["value"] = null; // Default To 'Any'
		this.dtUnassignedActions.filters.DefinedByDesc["value"] = null; // Default To 'Any'
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowDblClick
	//
	//-----------------------------------------------------------------------------------------------------
	onRowDblClick(item: any) {
		this.onEditComment();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddComment
	//
	//-----------------------------------------------------------------------------------------------------
	onAddComment() {
		this.ErrorMessage = "";

		//
		//	Display Edit Popup
		//
		let popup_header = "Add Comment";

		var ref = this.dialogService.open(DisciplineAddEditCommentComponent, {
			header: popup_header,
			width: "600px",
			data: {
				IncidentImageID: "",
				IncidentImageTitle: "",
				IncidentImageComment: "",
			},
		});

		ref.onClose.subscribe((response) => {
			if (response != null && response.isSave == true) {
				//
				//	Refresh Comment List
				//
				let rComment: wsDisciplineAdvancedIncidentCommentInfo = {
					IncidentImageID: response.IncidentImageID,
					c_date: new Date(),
					IncidentImageTitle: response.IncidentImageTitle,
					IncidentImageComment: response.IncidentImageComment,
					StaffName: this.rAdminName,
				};

				this.lstCommentItems = [...this.lstCommentItems, rComment];
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEditComment
	//
	//-----------------------------------------------------------------------------------------------------
	onEditComment() {
		this.ErrorMessage = "";

		if (this.SelectedComment == null) {
			this.ErrorMessage = "Please select a comment to edit.";
			return;
		}

		//
		//	Display Edit Popup
		//
		let popup_header = "Edit Comment";

		var ref = this.dialogService.open(DisciplineAddEditCommentComponent, {
			header: popup_header,
			width: "600px",
			data: {
				IncidentImageID: this.SelectedComment.IncidentImageID,
				IncidentImageTitle: this.SelectedComment.IncidentImageTitle,
				IncidentImageComment: this.SelectedComment.IncidentImageComment,
			},
		});

		ref.onClose.subscribe((response) => {
			if (response != null && response.isSave == true) {
				//
				//	Refresh Comment List
				//
				if (this.SelectedComment.IncidentImageID == response.IncidentImageID) {
					this.SelectedComment.c_date = new Date();
					this.SelectedComment.IncidentImageTitle = response.IncidentImageTitle;
					this.SelectedComment.IncidentImageComment = response.IncidentImageComment;
				}
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRemoveComment
	//
	//-----------------------------------------------------------------------------------------------------
	onRemoveComment() {
		this.ErrorMessage = "";

		if (this.SelectedComment == null) {
			this.ErrorMessage = "Please select a comment to remove.";
			return;
		}

		//
		// Confirm Remove
		//
		var message =
			"You are about to remove the comment '" +
			this.SelectedComment.IncidentImageComment +
			"' that was last changed on " +
			moment(this.SelectedComment.c_date).format("MMM d, YYYY, h:mm a") +
			". <br><br>" +
			"Do you wish to continue?";

		this.confirmationService.confirm({
			message: message,
			header: "Remove Comment",
			icon: "fa fa-info",
			accept: () => {
				//
				//	Remove The Selected Comment
				//
				this.lstCommentItems = this.lstCommentItems.filter((obj) => obj != this.SelectedComment);
				this.SelectedComment = null;
			},
			reject: () => {},
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFacilityLocationChange
	//
	//-----------------------------------------------------------------------------------------------------
	onFacilityLocationChange(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPlayAssigned
	//
	//-----------------------------------------------------------------------------------------------------
	onPlayAssigned() {
		if (this.SelectedAssignedPenalty != null && this.SelectedAssignedPenalty.SoundData.length > 10) {
			this.mp3Player.pause(); // First, Try to stop any playing files
			this.mp3Player = new Audio(this.SelectedAssignedPenalty.SoundData);
			this.mp3Player.play();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStopAssigned
	//
	//-----------------------------------------------------------------------------------------------------
	onStopAssigned() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPlayAssignable
	//
	//-----------------------------------------------------------------------------------------------------
	onPlayAssignable() {
		if (this.SelectedPenalty != null && this.SelectedPenalty.SoundData.length > 10) {
			this.mp3Player.pause(); // First, Try to stop any playing files
			this.mp3Player = new Audio(this.SelectedPenalty.SoundData);
			this.mp3Player.play();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStopAssignable
	//
	//-----------------------------------------------------------------------------------------------------
	onStopAssignable() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRadioChange
	//
	//-----------------------------------------------------------------------------------------------------
	onRadioChange() {
		if (this.selectedRadioValue == "1") {
			this.ValidateOption1Change();
		} else {
			this.ValidateOption2Change();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStartDate1Change
	//
	//-----------------------------------------------------------------------------------------------------
	onStartDate1Change(val) {
		this.rStartDate1 = val;
		this.ValidateOption1Change();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEndDate1Change
	//
	//-----------------------------------------------------------------------------------------------------
	onEndDate1Change(val) {
		this.rEndDate1 = val;
		this.ValidateOption1Change();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ValidateOption1Change	(Date Range)
	//
	//-----------------------------------------------------------------------------------------------------
	ValidateOption1Change() {
		this.ErrorMessage = "";

		if (this.rStartDate1 != null) {
			if (this.rStartDate1.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		if (this.rEndDate1 != null) {
			if (this.rEndDate1.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid End Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		if (this.rStartDate1 > this.rEndDate1) {
			this.ErrorMessage = "Start Date cannot be greater than End Date";
			return;
		}

		let parm: wsDisciplineAdvancedIncidentCalendarDataParm = {
			SchoolID: this.SchoolID,
			StartDate: this.rStartDate1,
			EndDate: this.rEndDate1,
			IsUseDayCount: false,
			DayCount: -1,
		};

		this.isBusy = true;
		this.dataService.DisciplineAdvancedIncidentGetCalendarData(parm).subscribe((data) => this.DisciplineAdvancedIncidentGetCalendarData_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentGetCalendarData_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentGetCalendarData_Complete(data: any) {
		var CalendarData: wsDisciplineAdvancedIncidentCalendarDataInfo;

		CalendarData = data;

		if (CalendarData.IsUseDayCount == true) {
			this.rEndDate2 = new Date(CalendarData.SuspEndDate); // Must do new for this to work
		} else {
			this.rSuspNbrDays1 = CalendarData.SuspNbrDays;

			if (this.rSuspNbrDays1 < this.rMinDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be less than " + this.rMinDurationDayCount.toString() + ".";
			}

			if (this.rSuspNbrDays1 > this.rMaxDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be greater than " + this.rMaxDurationDayCount.toString() + ".";
			}
		}

		if (CalendarData.isCalendarValid == false) {
			this.ErrorMessage = "Open calendar days does not support Suspension Days. First update school calendar.";
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSuspNbrDays2
	//
	//-----------------------------------------------------------------------------------------------------
	onSuspNbrDays2() {
		this.ValidateOption2Change();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStartDate2Change
	//
	//-----------------------------------------------------------------------------------------------------
	onStartDate2Change(val) {
		this.rStartDate2 = val;
		this.ValidateOption2Change();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEndDate2Change
	//
	//-----------------------------------------------------------------------------------------------------
	onEndDate2Change(val) {
		this.rEndDate2 = val;
		this.ValidateOption2Change();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ValidateOption2Change	(Day Count)
	//
	//-----------------------------------------------------------------------------------------------------
	ValidateOption2Change() {
		this.ErrorMessage = "";

		if (isNaN(Number(this.rSuspNbrDays2))) {
			this.ErrorMessage = "Number of days is not a number.";
			return;
		}

		if (Number(this.rSuspNbrDays2 < 1)) {
			this.ErrorMessage = "Number of days must be greater than 0.";
			return;
		}

		if (this.rSuspNbrDays2 < this.rMinDurationDayCount) {
			this.ErrorMessage = "Suspension Days cannot be less than " + this.rMinDurationDayCount.toString() + ".";
			return;
		}

		if (this.rSuspNbrDays2 > this.rMaxDurationDayCount) {
			this.ErrorMessage = "Suspension Days cannot be greater than " + this.rMaxDurationDayCount.toString() + ".";
			return;
		}

		if (this.rStartDate2 != null) {
			if (this.rStartDate2.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		let parm: wsDisciplineAdvancedIncidentCalendarDataParm = {
			SchoolID: this.SchoolID,
			StartDate: this.rStartDate2,
			EndDate: null,
			IsUseDayCount: true,
			DayCount: this.rSuspNbrDays2,
		};

		this.isBusy = true;
		this.dataService.DisciplineAdvancedIncidentGetCalendarData(parm).subscribe((data) => this.DisciplineAdvancedIncidentGetCalendarData_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfractionAInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfractionAInfo() {
		this.isShowInfractionAInfo = !this.isShowInfractionAInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfractionUInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfractionUInfo() {
		this.isShowInfractionUInfo = !this.isShowInfractionUInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onChangePrimaryInfraction
	//
	//-----------------------------------------------------------------------------------------------------
	onChangePrimaryInfraction(e: any) {
		this.ErrorMessage = "";

		this.lstAssignedInfractionItems.forEach((item) => {
			if (e.InfractionID != item.InfractionID) {
				item.isPrimary = false;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRemoveInfraction
	//
	//-----------------------------------------------------------------------------------------------------
	onRemoveInfraction() {
		this.ErrorMessage = "";

		if (this.SelectedAssignedInfraction == null) {
			this.ErrorMessage = "Please select an assigned infraction to remove.";
			return;
		}

		//
		//	Remove The Selected Item
		//
		this.lstAssignedInfractionItems = this.lstAssignedInfractionItems.filter((obj) => obj != this.SelectedAssignedInfraction);
		this.SelectedAssignedInfraction = null;

		//
		//	Refresh Assignable Action List
		//
		let AssignedInfractionItems: wsDisciplineAdvancedIncidentPenaltyRefreshInfractionsParm[] = [];

		this.lstAssignedInfractionItems.forEach((item) => {
			AssignedInfractionItems.push({
				InfractionID: item.InfractionID,
				isPrimary: item.isPrimary,
			});
		});

		let parm: wsDisciplineAdvancedIncidentPenaltyRefreshParm = {
			SchoolID: this.SchoolID,
			AssignedInfractionItems: AssignedInfractionItems,
		};

		this.isBusy = true;
		this.dataService.DisciplineAdvancedIncidentRefreshPenalty(parm).subscribe((data) => this.DisciplineAdvancedIncidentRefreshPenalty_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentRefreshPenalty_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentRefreshPenalty_Complete(data: any) {
		this.RefreshPenaltyData = data;

		this.SelectedPenalty = null;
		this.lstPenaltyItems = this.RefreshPenaltyData.PenaltyItems;

		//
		//	Set Filter Lists
		//
		this.lstActionSchoolsDescs = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.SchoolsDesc)));
		this.lstActionDefinedByDescs = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.DefinedByDesc)));

		//
		//	Set Filter Defaults
		//
		this.onSetActionFilterDefaults();

		//
		//	Reset Sort
		//
		this.dtAssignedActions.multiSortMeta = [];
		this.dtAssignedActions.multiSortMeta.push({
			field: "PenaltyDesc",
			order: 1,
		});
		this.dtAssignedActions.sortMultiple();

		this.dtUnassignedActions.multiSortMeta = [];
		this.dtUnassignedActions.multiSortMeta.push({
			field: "PenaltyDesc",
			order: 1,
		});
		this.dtUnassignedActions.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAssignInfraction
	//
	//-----------------------------------------------------------------------------------------------------
	onAssignInfraction() {
		this.ErrorMessage = "";

		if (this.SelectedInfraction == null) {
			this.ErrorMessage = "Please select an infraction to assign.";
			return;
		}

		let isItemExists: Boolean = false;

		this.lstAssignedInfractionItems.forEach((item) => {
			if (item.InfractionID == this.SelectedInfraction.InfractionID) {
				isItemExists = true;
			}
		});

		if (isItemExists == true) {
			this.ErrorMessage = "This infraction has already been assigned.";
			return;
		}

		let rInf: wsDisciplineAdvancedIncidentAssignedInfractionInfo = {
			InfractionID: this.SelectedInfraction.InfractionID,
			isPrimary: false,
			InfractionCD: this.SelectedInfraction.InfractionCD,
			InfractionDesc: this.SelectedInfraction.InfractionDesc,
			InfractionLevelDesc: this.SelectedInfraction.InfractionLevelDesc,
			DefinedByID: this.SelectedInfraction.DefinedByID,
			DefinedByDesc: this.SelectedInfraction.DefinedByDesc,
			SchoolID: this.SelectedInfraction.SchoolID,
			SchoolsDesc: this.SelectedInfraction.SchoolsDesc,
		};

		this.lstAssignedInfractionItems = [...this.lstAssignedInfractionItems, rInf];
		this.SelectedInfraction = null;

		//
		//	Refresh Assignable Action List
		//
		let AssignedInfractionItems: wsDisciplineAdvancedIncidentPenaltyRefreshInfractionsParm[] = [];

		this.lstAssignedInfractionItems.forEach((item) => {
			AssignedInfractionItems.push({
				InfractionID: item.InfractionID,
				isPrimary: item.isPrimary,
			});
		});

		let parm: wsDisciplineAdvancedIncidentPenaltyRefreshParm = {
			SchoolID: this.SchoolID,
			AssignedInfractionItems: AssignedInfractionItems,
		};

		this.isBusy = true;
		this.dataService.DisciplineAdvancedIncidentRefreshPenalty(parm).subscribe((data) => this.DisciplineAdvancedIncidentRefreshPenalty_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort_C
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort_C(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort_AI
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort_AI(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort_UI
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort_UI(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect_C
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect_C(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect_C
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect_C(event) {
		//
		//	Need to set SelectedInfraction here. We don't unselect when selected.
		//
		this.SelectedComment = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect_AI
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect_AI(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect_AI
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect_AI(event) {
		//
		//	Need to set SelectedInfraction here. We don't unselect when selected.
		//
		this.SelectedAssignedInfraction = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelectUI
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelectUI(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselectUI
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselectUI(event) {
		//
		//	Need to set SelectedInfraction here. We don't unselect when selected.
		//
		this.SelectedInfraction = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleActionAInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleActionAInfo() {
		this.isShowActionAInfo = !this.isShowActionAInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleActionUInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleActionUInfo() {
		this.isShowActionUInfo = !this.isShowActionUInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onChangePrimaryAction
	//
	//-----------------------------------------------------------------------------------------------------
	onChangePrimaryAction(e: any) {
		this.ErrorMessage = "";

		this.lstAssignedPenaltyItems.forEach((item) => {
			if (e.PenaltyID != item.PenaltyID) {
				item.isPrimary = false;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRemoveAction
	//
	//-----------------------------------------------------------------------------------------------------
	onRemoveAction() {
		this.ErrorMessage = "";

		if (this.SelectedAssignedPenalty == null) {
			this.ErrorMessage = "Please select an assigned action to remove.";
			return;
		}

		//
		//	Remove The Selected Item
		//
		this.lstAssignedPenaltyItems = this.lstAssignedPenaltyItems.filter((obj) => obj != this.SelectedAssignedPenalty);
		this.SelectedAssignedPenalty = null;

		//
		//	SUSP Check
		//
		this.rHasSusp = false;

		this.lstAssignedPenaltyItems.forEach((item) => {
			if (item.isSusp == true) {
				this.rHasSusp = true;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAssignAction
	//
	//-----------------------------------------------------------------------------------------------------
	onAssignAction() {
		this.ErrorMessage = "";

		if (this.SelectedPenalty == null) {
			this.ErrorMessage = "Please select an action to assign.";
			return;
		}

		let isItemExists: Boolean = false;

		this.lstAssignedPenaltyItems.forEach((item) => {
			if (item.PenaltyID == this.SelectedPenalty.PenaltyID) {
				isItemExists = true;
			}
		});

		if (isItemExists == true) {
			this.ErrorMessage = "This action has already been assigned.";
			return;
		}

		if (this.rHasSusp == true) {
			if (this.SelectedPenalty.isSusp == true) {
				this.ErrorMessage =
					"A Suspension Action is already assigned to this incident. You can only have one suspension type assigned to an incident at a time.";
				return;
			}
		}

		let rPen: wsDisciplineAdvancedIncidentAssignedPenaltyInfo = {
			PenaltyID: this.SelectedPenalty.PenaltyID,
			isPrimary: false,
			PenaltyCD: this.SelectedPenalty.PenaltyCD,
			PenaltyDesc: this.SelectedPenalty.PenaltyDesc,
			AlertID: this.SelectedPenalty.AlertID,
			Message: this.SelectedPenalty.Message,
			FontColor: this.SelectedPenalty.FontColor,
			DefinedByID: this.SelectedPenalty.DefinedByID,
			DefinedByDesc: this.SelectedPenalty.DefinedByDesc,
			SchoolID: this.SelectedPenalty.SchoolID,
			SchoolsDesc: this.SelectedPenalty.SchoolsDesc,
			isSusp: this.SelectedPenalty.isSusp,
			MinDurationDayCount: this.SelectedPenalty.MinDurationDayCount,
			MaxDurationDayCount: this.SelectedPenalty.MaxDurationDayCount,
			SoundData: this.SelectedPenalty.SoundData,
		};

		this.lstAssignedPenaltyItems = [...this.lstAssignedPenaltyItems, rPen];
		this.SelectedPenalty = null;

		//
		//	SUSP Check
		//
		this.rHasSusp = false;

		this.lstAssignedPenaltyItems.forEach((item) => {
			if (item.isSusp == true) {
				this.rHasSusp = true;
				this.rMinDurationDayCount = item.MinDurationDayCount; // Will only have 1 susp per Incident
				this.rMaxDurationDayCount = item.MaxDurationDayCount; // Will only have 1 susp per Incident
			}
		});

		if (this.rHasSusp != false) {
			// this.rHasSusp == true throws an error (Bug in VS Code)
			if (this.selectedRadioValue == "1") {
				//
				// Date Range
				//
				this.ValidateOption1Change();
			} else {
				//
				// Day Count
				//
				this.ValidateOption2Change();
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort_AA
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort_AA(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort_UA
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort_UA(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect_AA
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect_AA(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect_AA
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect_AA(event) {
		//
		//	Need to set SelectedPenalty here. We don't unselect when selected.
		//
		this.SelectedAssignedPenalty = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelectUA
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelectUA(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselectUA
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselectUA(event) {
		//
		//	Need to set SelectedPenalty here. We don't unselect when selected.
		//
		this.SelectedPenalty = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onAddUpdate() {
		this.ErrorMessage = "";

		if (this.lstAssignedInfractionItems.length == 0 || this.lstAssignedPenaltyItems.length == 0) {
			this.ErrorMessage = "At least one Infraction and one Action must be assigned.";
			return;
		}

		var HasPrimaryInfraction: boolean = false;
		var HasPrimaryAction: boolean = false;

		this.lstAssignedInfractionItems.forEach((item) => {
			if (item.isPrimary == true) {
				HasPrimaryInfraction = true;
			}
		});

		this.lstAssignedPenaltyItems.forEach((item) => {
			if (item.isPrimary == true) {
				HasPrimaryAction = true;
			}
		});

		if (HasPrimaryInfraction == false || HasPrimaryAction == false) {
			this.ErrorMessage = "At least one Infraction and one Action must be set to Primary.";
			return;
		}

		// Suspension Not Primary Check
		this.lstAssignedPenaltyItems.forEach((item) => {
			if (item.isSusp == true && item.isPrimary == false) {
				this.ErrorMessage = "The assigned Action '" + item.PenaltyCD + "' is a suspenstion and must be set to Primary.";
				return;
			}
		});

		//
		//	Validate Incident Date / Time
		//
		if (this.rIncidentDT != null) {
			if (this.rIncidentDT.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid Discipline Date. Date must be greater then 1/1/1753.";
				return;
			}
		} else {
			this.ErrorMessage = "Invalid Discipline Date.";
			return;
		}

		//
		//	IF Has SUSP! and selectedRadioValue = 1
		//
		if (this.rHasSusp == true && this.selectedRadioValue == "1") {
			if (this.rStartDate1 != null) {
				if (this.rStartDate1.getFullYear() < 1753) {
					// SQL Does not support dates < 1753
					this.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
					return;
				}
			}

			if (this.rEndDate1 != null) {
				if (this.rEndDate1.getFullYear() < 1753) {
					// SQL Does not support dates < 1753
					this.ErrorMessage = "Invalid End Date. Date must be greater then 1/1/1753.";
					return;
				}
			}

			if (this.rStartDate1 > this.rEndDate1) {
				this.ErrorMessage = "Start Date cannot be greater than End Date";
				return;
			}

			let parm: wsDisciplineAdvancedIncidentCalendarDataParm = {
				SchoolID: this.SchoolID,
				StartDate: this.rStartDate1,
				EndDate: this.rEndDate1,
				IsUseDayCount: false,
				DayCount: -1,
			};

			this.isBusy = true;
			this.dataService
				.DisciplineAdvancedIncidentGetCalendarData(parm)
				.subscribe((data) => this.DisciplineAdvancedIncidentGetCalendarDataForUpdate_Complete(data));
		}

		//
		//	IF Has SUSP! and selectedRadioValue = 2
		//
		if (this.rHasSusp == true && this.selectedRadioValue == "2") {
			if (isNaN(Number(this.rSuspNbrDays2))) {
				this.ErrorMessage = "Number of days is not a number.";
				return;
			}

			if (Number(this.rSuspNbrDays2 < 1)) {
				this.ErrorMessage = "Number of days must be greater than 0.";
				return;
			}

			if (this.rSuspNbrDays2 < this.rMinDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be less than " + this.rMinDurationDayCount.toString() + ".";
				return;
			}

			if (this.rSuspNbrDays2 > this.rMaxDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be greater than " + this.rMaxDurationDayCount.toString() + ".";
				return;
			}

			if (this.rStartDate2 != null) {
				if (this.rStartDate2.getFullYear() < 1753) {
					// SQL Does not support dates < 1753
					this.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
					return;
				}
			}

			let parm: wsDisciplineAdvancedIncidentCalendarDataParm = {
				SchoolID: this.SchoolID,
				StartDate: this.rStartDate2,
				EndDate: null,
				IsUseDayCount: true,
				DayCount: this.rSuspNbrDays2,
			};

			this.isBusy = true;
			this.dataService
				.DisciplineAdvancedIncidentGetCalendarData(parm)
				.subscribe((data) => this.DisciplineAdvancedIncidentGetCalendarDataForUpdate_Complete(data));
		}

		//
		//	IF Has no SUSP!
		//
		if (this.rHasSusp == false) {
			this.onProcessAddUpdate();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentGetCalendarDataForUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentGetCalendarDataForUpdate_Complete(data: any) {
		var CalendarData: wsDisciplineAdvancedIncidentCalendarDataInfo;

		CalendarData = data;

		if (CalendarData.IsUseDayCount == true) {
			this.rEndDate2 = new Date(CalendarData.SuspEndDate); // Must do new for this to work
		} else {
			this.rSuspNbrDays1 = CalendarData.SuspNbrDays;

			if (this.rSuspNbrDays1 < this.rMinDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be less than " + this.rMinDurationDayCount.toString() + ".";
			}

			if (this.rSuspNbrDays1 > this.rMaxDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be greater than " + this.rMaxDurationDayCount.toString() + ".";
			}
		}

		if (CalendarData.isCalendarValid == false) {
			this.ErrorMessage = "Open calendar days does not support Suspension Days. First update school calendar.";
		}

		this.isBusy = false;

		if (this.ErrorMessage.length == 0) {
			this.onProcessAddUpdate();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onProcessAddUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onProcessAddUpdate() {
		//
		//	All Validations Passed. Do the Add / Update
		//
		var parmIsUseDayCount: boolean = false;
		var parmSuspNbrDays: number = 0;
		var parmStartDate: Date = null;
		var parmEndDate: Date = null;

		if (this.rHasSusp == true) {
			if (this.selectedRadioValue == "1") {
				parmIsUseDayCount = false;
				parmSuspNbrDays = this.rSuspNbrDays1;
				parmStartDate = this.rStartDate1;
				parmEndDate = this.rEndDate1;
			} else {
				parmIsUseDayCount = true;
				parmSuspNbrDays = this.rSuspNbrDays2;
				parmStartDate = this.rStartDate2;
				parmEndDate = this.rEndDate2;
			}
		}

		// Build Comment List
		let lstAddUpdateCommentItems: wsDisciplineAdvancedIncidentAddUpdateComment[] = [];

		this.lstCommentItems.forEach((item) => {
			//	Convert From GMT DateTime to Local DateTime
			let str_c_date = new Date(item.c_date).toLocaleString("en-US");

			lstAddUpdateCommentItems.push({
				IncidentImageID: item.IncidentImageID,
				c_date: str_c_date,
				IncidentImageTitle: item.IncidentImageTitle,
				IncidentImageComment: item.IncidentImageComment,
			});
		});

		// Build Penality List
		let lstAddUpdateInfractionItems: wsDisciplineAdvancedIncidentAddUpdateInfraction[] = [];

		this.lstAssignedInfractionItems.forEach((item) => {
			lstAddUpdateInfractionItems.push({
				InfractionID: item.InfractionID,
				isPrimary: item.isPrimary,
			});
		});

		// Build Penality List
		let lstAddUpdatePenaltyItems: wsDisciplineAdvancedIncidentAddUpdatePenalty[] = [];

		this.lstAssignedPenaltyItems.forEach((item) => {
			lstAddUpdatePenaltyItems.push({
				PenaltyID: item.PenaltyID,
				isPrimary: item.isPrimary,
			});
		});

		//
		//	Build Main Parm For Add / Update
		//
		if (this.isAdd == true) {
			//
			//	Convert From GMT DateTime to Local DateTime
			//
			let strIncidentDT = new Date(this.rIncidentDT).toLocaleString("en-US");
			let strStartDate = new Date(parmStartDate).toLocaleString("en-US");
			let strEndDate = new Date(parmEndDate).toLocaleString("en-US");

			let parm: wsDisciplineAdvancedIncidentAddUpdateParm = {
				UserID: this.UserID,
				PersonID: this.PersonID,
				IncidentID: -1,
				IncidentDT: strIncidentDT,
				FacilityLocationID: this.SelectedFacilityLocation.FacilityLocationID,
				ContinueAlert: this.rContinueAlert,
				HasSusp: this.rHasSusp,
				IsUseDayCount: parmIsUseDayCount,
				SuspNbrDays: parmSuspNbrDays,
				StartDate: strStartDate,
				EndDate: strEndDate,
				ParentPortalSendNotification: this.ParentPortalSendNotification,
				StudentPortalSendNotification: this.StudentPortalSendNotification,
				StaffPortalSendNotification: this.StaffPortalSendNotification,
				CommentItems: lstAddUpdateCommentItems,
				AssignedInfractionItems: lstAddUpdateInfractionItems,
				AssignedPenaltyItems: lstAddUpdatePenaltyItems,
			};

			this.isBusy = true;
			this.dataService.DisciplineAdvancedIncidentAdd(parm).subscribe((data) => this.DisciplineAdvancedIncidentAdd_Complete(data));
		} else {
			//
			//	Convert From GMT DateTime to Local DateTime
			//
			let strIncidentDT = new Date(this.rIncidentDT).toLocaleString("en-US");
			let strStartDate = new Date(parmStartDate).toLocaleString("en-US");
			let strEndDate = new Date(parmEndDate).toLocaleString("en-US");

			let parm: wsDisciplineAdvancedIncidentAddUpdateParm = {
				UserID: this.UserID,
				PersonID: this.PersonID,
				IncidentID: this.IncidentID,
				IncidentDT: strIncidentDT,
				FacilityLocationID: this.SelectedFacilityLocation.FacilityLocationID,
				ContinueAlert: this.rContinueAlert,
				HasSusp: this.rHasSusp,
				IsUseDayCount: parmIsUseDayCount,
				SuspNbrDays: parmSuspNbrDays,
				StartDate: strStartDate,
				EndDate: strEndDate,
				ParentPortalSendNotification: this.ParentPortalSendNotification,
				StudentPortalSendNotification: this.StudentPortalSendNotification,
				StaffPortalSendNotification: this.StaffPortalSendNotification,
				CommentItems: lstAddUpdateCommentItems,
				AssignedInfractionItems: lstAddUpdateInfractionItems,
				AssignedPenaltyItems: lstAddUpdatePenaltyItems,
			};

			this.isBusy = true;
			this.dataService.DisciplineAdvancedIncidentUpdate(parm).subscribe((data) => this.DisciplineAdvancedIncidentUpdate_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentAdd_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentAdd_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
